const MoreIcon = (props) => {
    return (
        <svg
          width={30}
          height={30}
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M13.572 19.286L17.857 15l-4.285-4.286M17.857 15H5"
            stroke="#6E0202"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.428 12.143V7.846a2.857 2.857 0 012.846-2.857l11.36-.045a2.857 2.857 0 012.87 2.845l.056 14.328a2.857 2.857 0 01-2.846 2.868H9.286a2.857 2.857 0 01-2.858-2.857v-4.27"
            stroke="#6E0202"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
}

export default MoreIcon